import React from 'react';

import cls from './Container.module.scss';

const Container = ({ children }) => <div className={cls.wrapper}>{children}</div>;

export default Container;